/**
 * Created by Gaplo917 on 9/7/2017.
 */
import * as PIXI from "pixi.js";
import R from "../config/R"
import Scene from "../objects/Scene"
import FullScreenBg from "../objects/FullScreenBg"
import {Man} from "../characters/common/Man"
import * as Rx from 'rxjs'
import * as Events from "../Events"
import InfoScene from "./InfoScene"
import Button from "../objects/Button"
import Image from "../objects/Image"
import SoundManager from "../SoundManager"
import TWEEN from "@tweenjs/tween.js"

export class EndGameScene extends Scene {
  constructor(resources, settings){
    super()

    this.resources = resources
    this.settings = settings

    const bg = new FullScreenBg(resources[R.images.end_game_bg.name].texture)
    const restartBtn = (() => {
      const btn = new Button(1940,1450, resources[R.images.returnBtn.name].texture)
      btn.displayGroup = new PIXI.DisplayGroup(11, true)
      return btn
    })()
    const map = new Image(1198,1385, resources[R.images.map.name].texture)

    const man = new Man(-200, 1200, resources)

    map.scale.set(0.50)

    this.addChild(bg)
    this.addChild(man)
    this.addChild(map)
    this.addChild(restartBtn)

    restartBtn.addOnClickListener(() => {
      this.backToSelection()
    })

    const r0 = man.endGameWalking()
    const r1 = man.pickingUp(this,map)

    requestAnimationFrame(() => {
      r0
        .do(() => r1.subscribe())
        .delay(2700)
        .do(() => {
          this.popUpInfoScene(resources[R.images.success_03.name].texture)
          man.endGameStop()
          SoundManager.instance.stopEffect(R.sounds.sfx_clap)
        })
        .flatMap(() => {
          SoundManager.instance.stopAll()
          return SoundManager.instance.playEffectRx(R.sounds.game_feedback_good)
        })
        .subscribe()
    })


  }

  popUpInfoScene(texture){
    this.infoScene = new InfoScene(this.resources, texture)
    this.addChild(this.infoScene)
  }

  destroy(){
    TWEEN.removeAll()
    super.destroy({children: true})
  }

  backToSelection(){
    this.destroy()
    Events.hub.publishEvent(Events.NEXT_SCENE, { scene : R.scenes.SELECTION })
  }

}



// WEBPACK FOOTER //
// ./src/game/scenes/EndGameScene.js